module.exports = __webpack_public_path__ + "img/banner-trx.d7a2962f.jpg";